/**
 * 音响路由
 * */
export default [
  {
    path: "/soundIndex",
    name: "soundIndex",
    meta: {
      title: '首页'
    },
    component: () => import("@/views/soundSystem/index")
  },{
    path: '/soundSystemChannelList',
    name: 'soundSystemChannelList',
    component: () => import('@/views/soundSystem/deviceManage/channelList'),
    meta: {
      title: '渠道管理'
    }
  },{
    path: '/soundSystemMachineList',
    name: 'soundSystemMachineList',
    component: () => import('@/views/soundSystem/deviceManage/machineList'),
    meta: {
      title: '机型管理'
    }
  },{
    path: '/soundSystemDeviceList',
    name: 'soundSystemDeviceList',
    component: () => import('@/views/soundSystem/deviceManage/deviceList'),
    meta: {
      title: '设备管理'
    }
  },{
    path: '/soundSystemOtaManger',
    name: 'soundSystemOtaManger',
    component: () => import('@/views/soundSystem/apply/otaManger'),
    meta: {
      title: 'OTA管理'
    }
  },{
    path: '/soundSystemOtaDownloadLogs',
    name: 'soundSystemOtaDownloadLogs',
    component: () => import('@/views/soundSystem/apply/otaDownloadLogs'),
    meta: {
      title: 'OTA升级记录'
    }
  },{
    path: '/soundSystemImeiErrorLogList',
    name: 'soundSystemImeiErrorLogList',
    component: () => import('@/views/soundSystem/deviceManage/imeiErrorLogList'),
    meta: {
      title: '设备日志'
    }
  },{
    path: '/soundSystemAddModelPage',
    name: 'soundSystemAddModelPage',
    meta: {
      title: '新增机型'
    },
    component: () => import('@/views/soundSystem/deviceManage/addModelPage')
  },{
    path: '/soundSystemEditModelPage',
    name: 'soundSystemEditModelPage',
    meta: {
      title: '编辑机型'
    },
    component: () => import('@/views/soundSystem/deviceManage/editModelPage')
  },{
    path: '/soundDeviceMonthRegister',
    name: 'soundDeviceMonthRegister',
    meta: {
      title: '设备统计'
    },
    component: () => import('@/views/soundSystem/bi/deviceMonthRegister')
  },{
    path: '/soundSystemOtaUpdateAddPage',
    name: 'soundSystemOtaUpdateAddPage',
    meta: {
      title: 'OTA新增'
    },
    component: () => import('@/views/soundSystem/apply/otaUpdateAddPage')
  },{
    path: '/soundSystemOtaUpdateEditPage',
    name: 'soundSystemOtaUpdateEditPage',
    meta: {
      title: 'OTA编辑'
    },
    component: () => import('@/views/soundSystem/apply/otaUpdateEditPage')
  },{
    path: '/soundSystemDeviceQualityAssessment',
    name: 'soundSystemDeviceQualityAssessment',
    meta: {
      title: '智能检测'
    },
    component: () => import('@/views/soundSystem/deviceManage/deviceQualityAssessment')
  },{
    path: '/soundSystemDeviceLogView',
    name: 'soundSystemDeviceLogView',
    meta: {
      title: '设备日志'
    },
    component: () => import('@/views/soundSystem/baby/deviceLogView'),
  },{
    path: '/soundSystemSearchAppUse',
    name: 'soundSystemSearchAppUse',
    component: () => import('@/views/soundSystem/bi/searchAppUse'),
    meta: {
      title: '使用分析'
    },
  },{
    path: '/soundSystemChannelAppPage',
    name: 'soundSystemChannelAppPage',
    component: () => import('@/views/soundSystem/deviceManage/ChannelAppPage'),
    meta: {
      title: '渠道APP关系管理'
    },
  },{
    path: '/soundSystemOtaBiHome',
    name: 'soundSystemOtaBiHome',
    component: () => import('@/views/soundSystem/bi/otaBiHome'),
    meta: {
      title: 'OTA升级统计'
    },
  },{
    path: '/soundSystemCheckModel',
    name: 'soundSystemCheckModel',
    component: () => import('@/views/soundSystem/deviceManage/checkModel'),
    meta: {
      title: '查看机型'
    }
  },
  {
    path: '/soundKiDozApp',
    name: 'soundKiDozApp',
    component: () => import("@/views/soundSystem/bi/KiDozApp"),
    meta: {
      title: 'kiDozApp'
    }
  },
  {
    path: '/soundOtaRequestLog',
    name: 'soundOtaRequestLog',
    component: () => import("@/views/soundSystem/bi/otaRequestLog"),
    meta: {
      title: 'ota请求日志'
    }
  }, {
    path: '/soundVirtualSnBatchList',
    name: 'soundVirtualSnBatchList',
    component: () => import("@/views/soundSystem/deviceManage/virtualSnBatchList"),
    meta: {
      title: '授权批次'
    }
  }, {
    path: '/soundVirtualSnLicenseList',
    name: 'soundVirtualSnLicenseList',
    component: () => import("@/views/soundSystem/deviceManage/virtualSnLicenseList"),
    meta: {
      title: '授权许可'
    }
  }, {
    path: '/soundApkManager',
    name: 'soundApkManager',
    component: () => import("@/views/soundSystem/apply/apkManager"),
    meta: {
      title: 'APK管理'
    }
  },{
    path: '/soundApkUpdateAddPage',
    name: 'soundApkUpdateAddPage',
    meta: {
      title: 'Apk新增'
    },
    component: () => import('@/views/soundSystem/apply/apkUpdateAddPage')
  },{
    path: '/soundApkUpdateEditPage',
    name: 'soundApkUpdateEditPage',
    meta: {
      title: 'Apk编辑'
    },
    component: () => import('@/views/soundSystem/apply/apkUpdateEditPage')
  }, {
    path: '/soundAppManager',
    name: 'soundAppManager',
    component: () => import("@/views/soundSystem/apply/appManager"),
    meta: {
      title: 'APP管理'
    }
  },{
    path: '/soundAppUpdateEditPage',
    name: 'soundAppUpdateEditPage',
    meta: {
      title: 'App编辑'
    },
    component: () => import('@/views/soundSystem/apply/appUpdateEditPage')
  },{
    path: '/soundAppUpdateAddPage',
    name: 'soundAppUpdateAddPage',
    meta: {
      title: 'APP新增'
    },
    component: () => import('@/views/soundSystem/apply/appUpdateAddPage')
  },{
    path: '/soundDeviceInstruction',
    name: 'soundDeviceInstruction',
    component: () => import('@/views/soundSystem/deviceManage/deviceInstruction'),
    meta: {
      title: '设备指令'
    }
  },{
    path: '/soundUserList',
    name: 'soundUserList',
    component: () => import('@/views/soundSystem/baby/photoUserList'),
    meta: {
      title: '用户管理'
    }
  },{
    path: '/soundSystemDeviceNew',
    name: 'soundSystemDeviceNew',
    meta: {
      title: '设备管理(新)'
    },
    component: () => import('@/views/soundSystem/deviceManage/deviceNew')
  }
]



// WEBPACK FOOTER //
// ./src/router/soundRouter.js